import { defineComponent, ref, computed, toRef, watch, resolveComponent, openBlock, createElementBlock, normalizeClass, normalizeStyle, renderSlot, createElementVNode, createVNode, createCommentVNode } from 'vue';
import { useDraggable } from '@vueuse/core';
import { t as te } from '../OrAutocompleteV3-508d99c0.js';
import { OrIconButtonV3 as script$1 } from '../or-icon-button-v3/index.js';
import '@onereach/styles/screens.json';
import '@onereach/styles/tailwind.config.json';
import 'lodash/get';
import 'lodash/isElement';
import '../or-error-v3/index.js';
import '../or-hint-v3/index.js';
import '../or-input-box-v3/index.js';
import '../or-input-v3/index.js';
import '../OrInlineInputV3-46210775.js';
import '../or-inline-input-box-v3/index.js';
import '../or-text-v3/index.js';
import '../or-icon-v3/index.js';
import '../or-label-v3/index.js';
import '../or-loader-v3/index.js';
import '../or-menu-item-v3/index.js';
import '../or-tooltip-v3/index.js';
import '../or-popover-v3/index.js';
import '@floating-ui/dom';
import '../or-bottom-sheet-v3/index.js';
import '../or-overlay-v3/index.js';
import '../or-teleport-v3/index.js';
import '../or-tag-input-v3/index.js';
import '../or-tags-v3/index.js';
import '../or-button-v3/index.js';
import '../or-tag-v3/index.js';

var ResizeablePanelPadding;
(function (ResizeablePanelPadding) {
  ResizeablePanelPadding["L"] = "l";
  ResizeablePanelPadding["M"] = "m";
  ResizeablePanelPadding["S"] = "s";
  ResizeablePanelPadding["None"] = "none";
})(ResizeablePanelPadding || (ResizeablePanelPadding = {}));
var ResizeablePanelPlacement;
(function (ResizeablePanelPlacement) {
  ResizeablePanelPlacement["Top"] = "top";
  ResizeablePanelPlacement["Bottom"] = "bottom";
  ResizeablePanelPlacement["Left"] = "left";
  ResizeablePanelPlacement["Right"] = "right";
})(ResizeablePanelPlacement || (ResizeablePanelPlacement = {}));

const ResizeablePanel = [
// Layout
'shrink-0',
// Theme
'theme-background-default', 'dark:theme-background-default-dark'];
const ResizeablePanelPlacements = {
  [ResizeablePanelPlacement.Top]: [
  // Layout
  'layout-column'],
  [ResizeablePanelPlacement.Bottom]: [
  // Layout
  'layout-column-reverse'],
  [ResizeablePanelPlacement.Left]: [
  // Layout
  'layout-row !items-stretch',
  // Box
  'h-full min-h-0'],
  [ResizeablePanelPlacement.Right]: [
  // Layout
  'layout-row-reverse !items-stretch',
  // Box
  'h-full min-h-0']
};
const ResizeablePanelContent = [
// Layout
'layout-column grow',
// Overflow
'overflow-auto'];
const ResizeablePanelContentPaddings = {
  [ResizeablePanelPadding.L]: [
  // Spacing
  'px-lg', 'py-lg'],
  [ResizeablePanelPadding.M]: [
  // Spacing
  'px-md', 'py-md'],
  [ResizeablePanelPadding.S]: [
  // Spacing
  'px-sm', 'py-sm'],
  [ResizeablePanelPadding.None]: []
};
const ResizeablePanelContentPlaceholder = [];
const ResizeablePanelContentPlaceholderPlacements = {
  [ResizeablePanelPlacement.Top]: [
  // Box
  'h-[calc(theme(spacing.md)+theme(spacing.sm))]'],
  [ResizeablePanelPlacement.Bottom]: [
  // Box
  'h-[calc(theme(spacing.md)+theme(spacing.sm))]'],
  [ResizeablePanelPlacement.Left]: [
  // Box
  'w-[calc(theme(spacing.md)+theme(spacing.sm))]'],
  [ResizeablePanelPlacement.Right]: [
  // Box
  'w-[calc(theme(spacing.md)+theme(spacing.sm))]']
};
const ResizeablePanelResizeBar = [
// Position
'relative',
// Layout
'shrink-0',
// Layout (after)
'after:block',
// Theme (after)
'after:border-outline-variant', 'after:dark:border-outline-variant-dark',
// Theme (after, hover)
'after:hover:border-primary-hover', 'after:dark:hover:border-primary-hover-dark',
// Theme (after, activated)
'after:activated:border-primary-hover', 'after:dark:activated:border-primary-hover-dark'];
const ResizeablePanelResizeBarPlacements = {
  [ResizeablePanelPlacement.Top]: [
  // Layout
  'flex flex-col justify-center',
  // Interactivity
  'interactivity-resize-row',
  // Spacing
  '-my-[calc(theme(spacing.md)/2)]', 'py-[calc(theme(spacing.md)/2)]',
  // Theme (after)
  'after:border-b-1'],
  [ResizeablePanelPlacement.Bottom]: [
  // Layout
  'flex flex-col justify-center',
  // Interactivity
  'interactivity-resize-row',
  // Spacing
  '-my-[calc(theme(spacing.md)/2)]', 'py-[calc(theme(spacing.md)/2)]',
  // Theme (after)
  'after:border-t-1'],
  [ResizeablePanelPlacement.Left]: [
  // Layout
  'flex flex-row justify-center',
  // Interactivity
  'interactivity-resize-column',
  // Spacing
  '-mx-[calc(theme(spacing.md)/2)]', 'px-[calc(theme(spacing.md)/2)]',
  // Theme (after)
  'after:border-r-1'],
  [ResizeablePanelPlacement.Right]: [
  // Layout
  'flex flex-row justify-center',
  // Interactivity
  'interactivity-resize-column',
  // Spacing
  '-mx-[calc(theme(spacing.md)/2)]', 'px-[calc(theme(spacing.md)/2)]',
  // Theme (after)
  'after:border-l-1']
};
const ResizeablePanelCollapseButtonContainer = [
// Position
'absolute',
// Shape
'rounded-full',
// Box
'w-fit', 'h-fit',
// Typography
'leading-[0]',
// Theme
'theme-background-default', 'dark:theme-background-default-dark', 'theme-border-outline-variant border-1', 'dark:theme-border-outline-variant-dark'];
const ResizeablePanelCollapseButtonContainerPlacements = {
  [ResizeablePanelPlacement.Top]: [
  // Position
  'left-md'],
  [ResizeablePanelPlacement.Bottom]: [
  // Position
  'left-md'],
  [ResizeablePanelPlacement.Left]: [
  // Position
  'top-md'],
  [ResizeablePanelPlacement.Right]: [
  // Position
  'top-md']
};
const ResizeablePanelToolbar = [
// Layout
'shrink-0',
// Overflow
'overflow-auto',
// Spacing
'px-md', 'py-md', 'gap-md',
// Theme
'theme-border-outline-variant border-1', 'dark:theme-border-outline-variant-dark'];
const ResizeablePanelToolbarPlacements = {
  [ResizeablePanelPlacement.Top]: [
  // Layout
  'layout-row',
  // Theme
  '!border-t-0', '!border-x-0'],
  [ResizeablePanelPlacement.Bottom]: [
  // Layout
  'layout-row',
  // Theme
  '!border-b-0', '!border-x-0'],
  [ResizeablePanelPlacement.Left]: [
  // Layout
  'layout-column',
  // Theme
  '!border-l-0', '!border-y-0'],
  [ResizeablePanelPlacement.Right]: [
  // Layout
  'layout-column',
  // Theme
  '!border-r-0', '!border-y-0']
};

var script = defineComponent({
  name: 'OrResizeablePanel',
  components: {
    OrIconButton: script$1
  },
  props: {
    isOpen: {
      type: Boolean,
      default: true
    },
    width: {
      type: Number,
      default: 320
    },
    minWidth: {
      type: Number,
      default: 256
    },
    maxWidth: {
      type: Number,
      default: 384
    },
    padding: {
      type: String,
      default: () => ResizeablePanelPadding.M
    },
    placement: {
      type: String,
      default: () => ResizeablePanelPlacement.Right
    },
    resizeable: {
      type: Boolean,
      default: true
    },
    collapsible: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:state', 'open', 'close', 'resize'],
  expose: ['root', 'state', 'open', 'close', 'toggle'],
  setup(props, context) {
    // Refs
    const root = ref();
    const resizeBar = ref();
    // Styles
    const rootStyles = computed(() => ['or-resizeable-panel-v3', ...ResizeablePanel, ...ResizeablePanelPlacements[props.placement]]);
    const contentStyles = computed(() => [...ResizeablePanelContent, ...ResizeablePanelContentPaddings[props.padding]]);
    const contentPlaceholderStyles = computed(() => [...ResizeablePanelContentPlaceholder, ...ResizeablePanelContentPlaceholderPlacements[props.placement]]);
    const resizeBarStyles = computed(() => [...ResizeablePanelResizeBar, ...ResizeablePanelResizeBarPlacements[props.placement], ...(!props.resizeable || props.collapsible && state.value === 'closed' ? ['interactivity-none'] : [])]);
    const collapseButtonContainerStyles = computed(() => [...ResizeablePanelCollapseButtonContainer, ...ResizeablePanelCollapseButtonContainerPlacements[props.placement]]);
    const toolbarStyles = computed(() => [...ResizeablePanelToolbar, ...ResizeablePanelToolbarPlacements[props.placement]]);
    // State
    const {
      state,
      open,
      close,
      toggle
    } = te(toRef(props, 'isOpen'), context.emit);
    const collapseButtonIcon = computed(() => {
      if (state.value === 'open') {
        switch (props.placement) {
          case ResizeablePanelPlacement.Top:
            return 'keyboard_arrow_up';
          case ResizeablePanelPlacement.Bottom:
            return 'keyboard_arrow_down';
          case ResizeablePanelPlacement.Left:
            return 'keyboard_arrow_left';
          case ResizeablePanelPlacement.Right:
            return 'keyboard_arrow_right';
        }
      }
      if (state.value === 'closed') {
        switch (props.placement) {
          case ResizeablePanelPlacement.Top:
            return 'keyboard_arrow_down';
          case ResizeablePanelPlacement.Bottom:
            return 'keyboard_arrow_up';
          case ResizeablePanelPlacement.Left:
            return 'keyboard_arrow_right';
          case ResizeablePanelPlacement.Right:
            return 'keyboard_arrow_left';
        }
      }
      return 'menu';
    });
    const currentDirection = computed(() => {
      switch (props.placement) {
        case ResizeablePanelPlacement.Top:
        case ResizeablePanelPlacement.Bottom:
          return 'height';
      }
      return 'width';
    });
    const currentSize = ref(props.width);
    watch(() => props.width, value => {
      currentSize.value = value;
    });
    // Effects
    // #region Resize
    let referencePoint = 0;
    const {
      isDragging
    } = useDraggable(resizeBar, {
      onStart: (_position, event) => {
        if (props.resizeable) {
          switch (props.placement) {
            case ResizeablePanelPlacement.Top:
            case ResizeablePanelPlacement.Bottom:
              referencePoint = event.y;
              break;
            case ResizeablePanelPlacement.Left:
            case ResizeablePanelPlacement.Right:
              referencePoint = event.x;
              break;
          }
          document.body.style.userSelect = 'none';
        }
      },
      onMove: position => {
        if (props.resizeable) {
          let nextWidth = 0;
          switch (props.placement) {
            case ResizeablePanelPlacement.Top:
              nextWidth = currentSize.value + (position.y - referencePoint);
              referencePoint = position.y;
              break;
            case ResizeablePanelPlacement.Bottom:
              nextWidth = currentSize.value + (referencePoint - position.y);
              referencePoint = position.y;
              break;
            case ResizeablePanelPlacement.Left:
              nextWidth = currentSize.value + (position.x - referencePoint);
              referencePoint = position.x;
              break;
            case ResizeablePanelPlacement.Right:
              nextWidth = currentSize.value + (referencePoint - position.x);
              referencePoint = position.x;
              break;
          }
          if (nextWidth < props.minWidth) {
            nextWidth = props.minWidth;
          }
          if (nextWidth > props.maxWidth) {
            nextWidth = props.maxWidth;
          }
          if (nextWidth !== currentSize.value) {
            context.emit('resize', currentSize.value = nextWidth);
          }
        }
      },
      onEnd: () => {
        if (props.resizeable) {
          document.body.style.userSelect = '';
        }
      }
    });
    // #endregion
    return {
      root,
      resizeBar,
      rootStyles,
      contentStyles,
      contentPlaceholderStyles,
      resizeBarStyles,
      collapseButtonContainerStyles,
      toolbarStyles,
      state,
      open,
      close,
      toggle,
      collapseButtonIcon,
      currentDirection,
      currentSize,
      isDragging
    };
  }
});

const _hoisted_1 = ["activated"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrIconButton = resolveComponent("OrIconButton");
  return openBlock(), createElementBlock("div", {
    ref: 'root',
    class: normalizeClass(_ctx.rootStyles),
    style: normalizeStyle({
      [_ctx.currentDirection]: !_ctx.collapsible || _ctx.state === 'open' ? `${_ctx.currentSize}px` : 'auto'
    })
  }, [!_ctx.collapsible || _ctx.state === 'open' ? (openBlock(), createElementBlock("div", {
    key: 0,
    class: normalizeClass(_ctx.contentStyles)
  }, [renderSlot(_ctx.$slots, "default")], 2 /* CLASS */)) : (openBlock(), createElementBlock("div", {
    key: 1,
    class: normalizeClass(_ctx.contentPlaceholderStyles)
  }, null, 2 /* CLASS */)), createElementVNode("div", {
    ref: 'resizeBar',
    class: normalizeClass(_ctx.resizeBarStyles),
    activated: _ctx.isDragging
  }, [_ctx.collapsible ? (openBlock(), createElementBlock("div", {
    key: 0,
    class: normalizeClass(_ctx.collapseButtonContainerStyles)
  }, [createVNode(_component_OrIconButton, {
    "additional-styles": ['p-xs'],
    icon: _ctx.collapseButtonIcon,
    color: 'primary',
    size: 'm',
    onClick: _cache[0] || (_cache[0] = $event => _ctx.toggle())
  }, null, 8 /* PROPS */, ["icon"])], 2 /* CLASS */)) : createCommentVNode("v-if", true)], 10 /* CLASS, PROPS */, _hoisted_1), _ctx.$slots.toolbar ? (openBlock(), createElementBlock("div", {
    key: 2,
    class: normalizeClass(_ctx.toolbarStyles)
  }, [renderSlot(_ctx.$slots, "toolbar")], 2 /* CLASS */)) : createCommentVNode("v-if", true)], 6 /* CLASS, STYLE */);
}

script.render = render;
script.__file = "src/components/or-resizeable-panel-v3/OrResizeablePanel.vue";

export { script as OrResizeablePanelV3, ResizeablePanelPadding, ResizeablePanelPlacement };
